var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C12.9283 5 13.8185 5.36875 14.4749 6.02513C15.1313 6.6815 15.5 7.57174 15.5 8.5C15.5 9.42826 15.1313 10.3185 14.4749 10.9749C13.8185 11.6313 12.9283 12 12 12C11.0717 12 10.1815 11.6313 9.52513 10.9749C8.86875 10.3185 8.5 9.42826 8.5 8.5C8.5 7.57174 8.86875 6.6815 9.52513 6.02513C10.1815 5.36875 11.0717 5 12 5ZM12 19C12 19 19 19 19 17.25C19 15.15 15.5875 12.875 12 12.875C8.4125 12.875 5 15.15 5 17.25C5 19 12 19 12 19Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconGray);
export default __webpack_public_path__ + "static/media/user-icon-gray.01ffdc89468fc736abf43a0b317036f1.svg";
export { ForwardRef as ReactComponent };